export default {
	showMoreLabel: "show more",
	showFewerLabel: "show fewer",
};
